/**
 * Sham Announcement Bar - Web Component
 * Handles the ticker animation and pausing logic.
 */

class ShamAnnouncementBar extends HTMLElement {
    constructor() {
        super();
        this.ticker = null;
    }

    connectedCallback() {
        this.ticker = this.querySelector('[data-ticker]');
        if (!this.ticker) return;

        this.init = this.initTicker.bind(this);

        // More robust wait for custom elements & fonts
        if (document.readyState === 'complete') {
            setTimeout(this.init, 500);
        } else {
            window.addEventListener('load', () => setTimeout(this.init, 500));
        }

        window.addEventListener('resize', this.init);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.init);
    }

    initTicker() {
        const items = Array.from(this.ticker.children);
        const blockCount = parseInt(this.getAttribute('data-block-count') || 1);

        if (items.length < blockCount) return;

        // Calculate the exact width of ONE set using getBoundingClientRect for sub-pixel precision
        let oneSetWidth = 0;
        for (let i = 0; i < blockCount; i++) {
            oneSetWidth += items[i].getBoundingClientRect().width;
        }

        if (oneSetWidth <= 0) return;

        const speed = parseInt(this.getAttribute('data-speed') || 40);
        const duration = oneSetWidth / speed;

        // Use precise floating point string for the shift
        this.ticker.style.setProperty('--sham-ticker-shift', `-${oneSetWidth.toFixed(4)}px`);
        this.ticker.style.animation = 'none';
        this.ticker.offsetHeight; // Force reflow
        this.ticker.style.animation = `sham-ticker ${duration.toFixed(4)}s linear infinite`;

        // Accessibility: Pause on focus & Hover
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
    }

    pause() {
        this.ticker.style.animationPlayState = 'paused';
    }

    play() {
        this.ticker.style.animationPlayState = 'running';
    }
}

if (!customElements.get('sham-announcement-bar')) {
    customElements.define('sham-announcement-bar', ShamAnnouncementBar);
}
